// src/components/RequireAuth.jsx

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

// Shared auth guard — used both for standalone routes in App.jsx and for
// individual tabs inside HomeScreen's internal tab switcher.
export function RequireAuth({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

export default RequireAuth;